import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseButton from '../../../components/Button/CloseButton';

type Props = {
    open: boolean;
    onClose: () => void;
};

const NoMoreLeadsDialog = ({ open, onClose }: Props) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>No more leads</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    You're viewing the last lead in your current work view. Try updating your filters to discover more
                    leads.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <CloseButton onClick={onClose}>Close</CloseButton>
            </DialogActions>
        </Dialog>
    );
};

export default NoMoreLeadsDialog;
